var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_405_1541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9418 5.03644C21.9008 5.01244 14.7558 1.71445 14.7558 1.71445C13.04 0.769499 10.9597 0.769499 9.24384 1.71445C9.24384 1.71445 2.09986 5.01244 2.05786 5.03644C0.144748 6.07786 -0.561892 8.47303 0.47953 10.3861C0.84267 11.0533 1.39073 11.6013 2.05786 11.9645C2.09986 11.9885 4.99987 13.3285 4.99987 13.3285V18.0555C5.00269 20.0915 6.32855 21.8894 8.27287 22.4935C9.48384 22.8433 10.7395 23.014 11.9999 23.0005C13.2603 23.014 14.5159 22.8433 15.7268 22.4935C17.6712 21.8893 18.997 20.0915 18.9998 18.0555V13.3284L20.9998 12.4064V19.5004C20.9998 20.3288 21.6714 21.0004 22.4998 21.0004C23.3282 21.0004 23.9998 20.3288 23.9998 19.5004V8.46141C23.9602 6.98686 23.2555 5.67642 21.9418 5.03644ZM15.9998 18.0554C16.0035 18.77 15.5426 19.4042 14.8618 19.6214C12.987 20.1244 11.0127 20.1244 9.13781 19.6214C8.457 19.4042 7.99617 18.77 7.99983 18.0554V14.7124L9.24384 15.2864C10.959 16.2338 13.0406 16.2338 14.7558 15.2864L15.9998 14.7124V18.0554H15.9998ZM20.4848 9.34041C20.4848 9.34041 13.3558 12.6304 13.3158 12.6544C12.4998 13.1185 11.4997 13.1185 10.6838 12.6544C10.6438 12.6304 3.51478 9.34041 3.51478 9.34041C3.05086 9.10373 2.86664 8.5358 3.10331 8.07187C3.19364 7.89478 3.33769 7.75078 3.51478 7.66041C3.51478 7.66041 10.6438 4.37039 10.6838 4.34639C11.4997 3.88233 12.4998 3.88233 13.3158 4.34639C13.3558 4.37039 20.4848 7.66041 20.4848 7.66041C20.9487 7.89708 21.1329 8.46501 20.8963 8.92894C20.8059 9.10608 20.6619 9.25008 20.4848 9.34041Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_405_1541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminWhite);
export default __webpack_public_path__ + "static/media/admin_white.fec1aebb753ff7c36e9cbfb60475ce16.svg";
export { ForwardRef as ReactComponent };